import React from 'react';
import PropTypes from 'prop-types';
import { Modal, Button } from 'antd';
import styled from 'styled-components';
import FormValueSelector from '../../../containers/FormValueSelector';

const StyledModal = styled(Modal)`
  .ant-modal-content {
    padding: 0;
    height: 100%;
    background-color: rgb(74, 74, 74);
  }
  .ant-modal-body {
    padding: 0;
    overflow: ${({ scrollable }) => (scrollable ? 'auto' : 'hidden')};
    height: 100%;
  }
  .ant-modal-footer {
    border-top: none;
  }
`;

const E2Preview = ({ creative, formName, visible, hideModal }) => (
  <FormValueSelector selector={(select, form, sectionPrefix, values) => values}>
    {(values = {}) => {
      const {
        creative_type,
        creative_url,
        click_action,
        creative_image,
        click_through_url,
        creative_html,
        scrollable,
        width,
        height,
      } = values;

      let env = process.env.REACT_APP_INMARKET_API.split('-')[0];

      // This is prod, so lets just default to qa1
      if (env.length > 11) env = 'https://qa1';

      const url = `${env}-engagement.inmarket.com`;
      let ad = creative_url;

      if (creative_type === 'image_upload') {
        ad = creative_image;
      } else if (creative_type === 'html_upload') {
        ad = creative_html;
      } else if (creative_type === 'cmp_tag') {
        ad = btoa(creative_html);
      }

      const params = {
        payload: 'preview',
        url: `${env}-m2m.inmarket.com/preview/?ad=${ad}`,
        width,
        height,
        creative_type,
        interstitial_html: ad,
        click_action,
        click_through_url,
        scrollable: !!scrollable,
        engagement_app_icon: 'checkpoints@2x.png',
        preview_in_browser: 1,
      };
      const query = Object.entries(params)
        .map(([key, val]) => `${key}=${val}`)
        .join('&');

      const finalURL = `${url}?${query}`;
      console.log('Final preview link:', finalURL);

      return (
        <StyledModal
          zIndex={1002}
          destroyOnClose
          scrollable={scrollable}
          closable={false}
          title={null}
          onCancel={hideModal}
          width={320}
          footer={[
            <Button key="submit" type="primary" onClick={hideModal}>
              Done
            </Button>,
          ]}
          height={592}
          visible={visible}
        >
          <iframe
            title="E2 Preview"
            id="prv"
            scrolling="no"
            width="320"
            height="592"
            align="top"
            frameBorder="0"
            src={finalURL}
          />
        </StyledModal>
      );
    }}
  </FormValueSelector>
);

E2Preview.defaultProps = {
  visible: false,
  formName: 'InStoreTab',
};

E2Preview.propTypes = {
  creative: PropTypes.object,
  hideModal: PropTypes.func.isRequired,
  visible: PropTypes.bool,
  formName: PropTypes.string,
};

export default E2Preview;
